import { titleCaseFieldLabel } from "./recordIdentity";

/** Where source properties come from, worded for any source system. */
export const SOURCE_PROPERTIES_HELP =
  "Properties copied from the system this document was synced from, such as identifiers, revisions, or status. They are kept up to date as the document changes in that system.";

/** One displayable source property. */
export interface SourceMetadataEntry {
  key: string;
  label: string;
  value: string;
}

/**
 * A record's source-system properties (`data.source_metadata`), in the
 * source's key order, ready to display.
 *
 * Edge-agent document sources set the field and its keys vary per customer,
 * so nothing here assumes a schema. Strings are trimmed, numbers stringified,
 * and booleans read Yes/No like the extracted metadata; blank strings, nulls,
 * arrays, and objects are skipped. Every surface labels keys through this one
 * function so a key reads the same everywhere.
 */
export const getSourceMetadata = (
  data: { source_metadata?: unknown } | null | undefined,
): SourceMetadataEntry[] => {
  const raw = data?.source_metadata;
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return [];
  return Object.entries(raw).flatMap(([key, value]) => {
    let text: string | null = null;
    if (typeof value === "string") text = value.trim();
    else if (typeof value === "number") text = String(value);
    else if (typeof value === "boolean") text = value ? "Yes" : "No";
    return text ? [{ key, label: titleCaseFieldLabel(key), value: text }] : [];
  });
};
